import { render, staticRenderFns } from "./FigmaPreview.vue?vue&type=template&id=9703df30"
import script from "./FigmaPreview.vue?vue&type=script&lang=js"
export * from "./FigmaPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports